import { render, staticRenderFns } from "./PFRTModal.vue?vue&type=template&id=04f11343&scoped=true"
import script from "./PFRTModal.vue?vue&type=script&lang=js"
export * from "./PFRTModal.vue?vue&type=script&lang=js"
import style0 from "./PFRTModal.vue?vue&type=style&index=0&id=04f11343&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f11343",
  null
  
)

export default component.exports